// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".information_root__3Q3cb {\n  display: flex;\n  align-items: center;\n  color: #333333;\n  font-size: 12px;\n  line-height: 18px; }\n  .information_root__3Q3cb .information_value__1oYP9 {\n    font-weight: bold;\n    margin-left: 9px; }\n", ""]);
// Exports
exports.locals = {
	"root": "information_root__3Q3cb",
	"value": "information_value__1oYP9"
};
module.exports = exports;
